var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferenda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89061 11.9131H14.1094C14.2918 11.9131 14.4652 11.9929 14.5839 12.1314L16.448 14.3061C16.7955 14.7116 16.5074 15.3379 15.9735 15.3379H3.02655C2.49258 15.3379 2.20451 14.7116 2.55201 14.3061L4.41607 12.1314C4.53481 11.9929 4.70816 11.9131 4.89061 11.9131Z",
    stroke: "#778192",
    strokeWidth: 0.75
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.23856,
    y: 8.5752,
    width: 11.2061,
    height: 8.34948,
    rx: 0.5,
    transform: "rotate(-44.5554 3.23856 8.5752)",
    fill: "#778192"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31277 8.14396L8.60495 9.25154L12.4815 5.375",
    stroke: "white",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferenda);
export default __webpack_public_path__ + "static/media/referenda.c5515e98.svg";
export { ForwardRef as ReactComponent };